import { Button, Breadcrumb, BPanel, Table, FormControl, Col } from '@sketchpixy/rubix';
import { Link } from 'react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import { Meteor } from 'meteor/meteor';
import moment from 'moment';
import { Reactive } from '../common/Reactive.mixin.js';
import { Reservations } from '../../collections/reservations/reservations';
import { GroupBills } from '../../collections/partners/group-bills';

import { UserSchema } from '../../collections/users/users';
import MgfTableComponent from '../common/mgfTable';

@Reactive({
	subscriptions: ["users", "reservations-all", "group-bills"],
	partners: Meteor.users.find({roles:{$in:['partner']}, 'profile.billType': 'groupe'}),
})
export default class GroupBillAddPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	selectPartner(ref) {
		let partnerId = ref.target.value;

		this.setState({
			//totalBills: Reservations.find({userId: partnerId, groupBill: null}).count(),
			partnerId: partnerId,
			month: ''
		});

		ReactDOM.findDOMNode(this.refs.month).value = '';
	}

	selectMonth(ref) {
		let month = ref.target.value;

		this.setState({
			month: moment(month).toDate()
		});

		let startDate = moment(month).startOf('month').toDate();
		let endDate = moment(month).endOf('month').toDate();

		console.log(Reservations.find({userId: this.state.partnerId, groupBill: null, createdAt: {$gte: startDate, $lte: endDate}}).count());

		this.setState({
			totalBills: Reservations.find({userId: this.state.partnerId, groupBill: null, createdAt: {$gte: startDate, $lte: endDate}}).count()
		});
	}

	bill(partnerId, month) {
		let that = this;
		this.setState({
			totalBills: 0
			});

		Meteor.call('groupBills.insert', {partnerId, month}, (function (err, _id) {
			if (err) {
	          Messenger().post({
	            message: "Erreur...",
	            type: "error"
	          });
	          return;
	        }

	        Messenger().post({
	          message: "Facture enregistrée !",
	          type: "success"
	        });

		}));
	}

	render() {

		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/group-bills">Factures groupées</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						<Link to="/group-bills/add"><Button bsStyle="success">Créer</Button></Link>
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Factures groupées">

					<Col sm={6}>
						{this.props.isReady &&
						<FormControl componentClass="select" placeholder="select" ref="partner" onChange={this.selectPartner.bind(this)}>
							<option>-</option>
							{this.props.partners.map((partner) => (
								<option value={partner._id}>{(partner && partner.displayName()) || 'N/C'}</option>
							))}
						</FormControl>
						}
					</Col>

					<Col sm={3}>
							<FormControl componentClass="select" placeholder="select" ref="month" onChange={this.selectMonth.bind(this)}>
									<option>-</option>
									<option value={moment().subtract(6, 'months').toDate()}>{moment().subtract(6, 'months').format('MMM YYYY')}</option>
									<option value={moment().subtract(5, 'months').toDate()}>{moment().subtract(5, 'months').format('MMM YYYY')}</option>
									<option value={moment().subtract(4, 'months').toDate()}>{moment().subtract(4, 'months').format('MMM YYYY')}</option>
									<option value={moment().subtract(3, 'months').toDate()}>{moment().subtract(3, 'months').format('MMM YYYY')}</option>
									<option value={moment().subtract(2, 'months').toDate()}>{moment().subtract(2, 'months').format('MMM YYYY')}</option>
									<option value={moment().subtract(1, 'months').toDate()}>{moment().subtract(1, 'months').format('MMM YYYY')}</option>
									<option value={moment().toDate()}>{moment().format('MMM YYYY')}</option>
									<option value={moment().add(1, 'months').toDate()}>{moment().add(1, 'months').format('MMM YYYY')}</option>
									<option value={moment().add(2, 'months').toDate()}>{moment().add(2, 'months').format('MMM YYYY')}</option>
									<option value={moment().add(3, 'months').toDate()}>{moment().add(3, 'months').format('MMM YYYY')}</option>
									<option value={moment().add(4, 'months').toDate()}>{moment().add(4, 'months').format('MMM YYYY')}</option>
									<option value={moment().add(5, 'months').toDate()}>{moment().add(5, 'months').format('MMM YYYY')}</option>
									<option value={moment().add(6, 'months').toDate()}>{moment().add(6, 'months').format('MMM YYYY')}</option>
							</FormControl>
					</Col>

					<Col sm={3}>
							{(this.state.totalBills > 0 && this.state.month) &&
							<Button bsStyle="success" onClick={this.bill.bind(this, this.state.partnerId, this.state.month)} >Facturer ({this.state.totalBills})</Button>
							}

							{(this.state.totalBills == 0 && this.state.month) &&
							<Button>Rien à facturer</Button>
							}

							{(this.state.month == null) &&
								<Button>Aucun mois séléctionné !</Button>
							}
					</Col>

					<br/><br/>
					<center>
						<Link to="/group-bills">Retour aux factures groupées</Link>
					</center>

				</BPanel>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/partners/GroupBillAdd.page.js
 **/